/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getTrackingUpdates } from "api/services/shipment";
import { useCustomQuery } from "hooks/useCustomQuery";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export const useGetTrackingUpdates = (shipmentId: string, options?: UseQueryOptions): any =>
  useCustomQuery({
    queryKey: shipmentQueryKeys.shipmentGeoDataDetails(shipmentId),
    queryFn: () => getTrackingUpdates(shipmentId).then((res) => res.data),
    ...options,
  });
